module.exports = "<img *ngIf=\"base64File\" alt=\"Image preview\" class=\"image-preview\"  src=\"{{base64File}}\">\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.html
// module id = ./web/modern/components/common/media-drop-zone/custom-media-preview/custom-media-preview.component.html
// module chunks = 0